const comparingArrays = (firstArrays?: string[], secondArrays?: string[]) => JSON.stringify(firstArrays) === JSON.stringify(secondArrays);

export {
    comparingArrays,
};
